import { SearchTerm } from './SearchTerm';

const UserTransactionSearch: SearchTerm[] = [
    {
        heading: "Event",
        accessor: "event",
        searchOnName: "eventType.nameOriginal",
        translationKey: "event"
    },
    {
        heading: "Master Controller",
        accessor: "masterController",
        searchOnName: "controller.devName",
        translationKey: "masterController"
    },
    {
        heading: "Reader",
        accessor: "reader",
        searchOnName: "terminal.devName",
        translationKey: "reader"
    },
    {
        heading: "Transaction Type",
        accessor: "transactionType",
        searchOnName: "transackType.trnName",
        translationKey: "transactionType"
    },
    {
        heading: "Building",
        accessor: "building",
        searchOnName: "trBuildingName",
        translationKey: "building"
    },
    {
        heading: "Floor",
        accessor: "floor",
        searchOnName: "trFloorName",
        translationKey: "floor"
    },
    {
        heading: "Zone",
        accessor: "zone",
        searchOnName: "trZoneName",
        translationKey: "zone"
    },
    {
        heading: "Card Number",
        accessor: "tagCode",
        searchOnName: "trTagcode",
        translationKey: "cardNumber"
    },
    {
        heading: "Fixed Address",
        accessor: "fixedAddress",
        searchOnName: "trDevFixedaddr",
        translationKey: "fixedAddress"
    },
    {
        heading: "Logical Address",
        accessor: "logicalAddress",
        searchOnName: "trSla",
        translationKey: "logicalAddress"
    },
    {
        heading: "Serial Address",
        accessor: "serialAddress",
        searchOnName: "trDevSerial",
        translationKey: "serialAddress"
    },
    {
        heading: "Door",
        accessor: "door",
        searchOnName: "trLocName",
        translationKey: "door"
    },
    {
        heading: "Reason Code",
        accessor: "reasonCode",
        searchOnName: "trReasoncode",
        translationKey: "reasonCode"
    },
    {
        heading: "Device Type",
        accessor: "deviceType",
        searchOnName: " unitType.nameOriginal",
        translationKey: "deviceType"
    },
    {
        heading: "Direction",
        accessor: "direction",
        searchOnName: "trDirection",
        translationKey: "direction"
    },
]

export default UserTransactionSearch;
